/**
 * Form error/success message handler
 * Check signup.js to see the example
 * Usage:
 *  Import by require
 *      var formMessageHandler = require('../components/FormMessageHandler').formMessageHandler;
 *  Init the js
 *      formMessageHandler.init($('.form_class'));
 */

export default class FormMessageHandler {
  constructor(form) {
    this.form = form;
    this.errorTemplate = $("<label class='error-message'></label>");
  }

  showError(name, message) {
    if(!message) {
      console.error('Can not find message for "' + name + '"');
      return;
    }

    if (name == "default") {
      $('.error-message--global', this.form).html(message).show();
    } else {
      let input = this.getFieldByName(name);
      input.parent().find('label.error-message').remove();
      input.removeClass('is_success').addClass('is_error');

      this.errorTemplate.html(message);
      let errorMessage = this.errorTemplate.clone();
      errorMessage.insertBefore(input);
      if (message.indexOf('br') != -1 || errorMessage.height() > 26) {
        errorMessage.addClass('two-line');
      }
    }
  }

  showSuccess(name) {
    let input = this.getFieldByName(name);
    input.removeClass('is_error').addClass('is_success');
    input.parent().find('label.error-message').remove();
  }

  getFieldByName(name) {
    let input = $("[name='" + name + "']", this.form);
    if (input.length == 0) {
      return false;
    }

    return input;
  }

  removeError(name) {
    let input = this.getFieldByName(name);
    input.removeClass('is_error');
    input.parent().find('label.error-message').remove();
  }
}
